import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from './modules/auth'
import dummy from './modules/dummy'
import middleware from './middleware'
import getDataFromStorage from '@/helpers/getDataFromStorage'
import other from './modules/other'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'recapulation' } },
    ...other,
    ...dummy,
    ...auth,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const { tokenCurrent } = getDataFromStorage()
  if (to.meta.middleware) {
    const context = {
      to, from, next,
    }
    const middlewareOfMeta = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]
    return middleware(context, middlewareOfMeta)
  }

  if (to.meta.authenticationPage && tokenCurrent) {
    return next('/')
  }

  return next()
})
// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
